<!-- 提交审核成功提示页面 -->
<template>
    <div class="page">
        <div class="content">
            <div class="success-icon" aria-hidden="true">
                <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="32" cy="32" r="32" fill="#2f9b63"/>
                    <path
                        d="M18.5 32.5l9.2 9.2 17.8-19.4"
                        stroke="#fff"
                        stroke-width="4.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </div>

            <p class="success-sub">预约已提交</p>
            <h1 class="success-title">等待项目管家审核</h1>

            <div class="booking-card">
                <div class="card-top">
                    <span class="date-text">{{ dateLabel }}</span>
                    <span class="status-badge">待审核</span>
                </div>

                <div class="room-name">{{ roomName }}</div>
                <div class="room-location">{{ location }}</div>

                <div class="time-row">
                    <span class="time-val">{{ startTime }}</span>
                    <span class="time-line" aria-hidden="true"></span>
                    <span class="time-val">{{ endTime }}</span>
                </div>

                <div class="tip-box">
                    <span class="tip-icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="9" stroke="#7aa7e0" stroke-width="1.8"/>
                            <circle cx="12" cy="12" r="2.2" fill="#7aa7e0"/>
                        </svg>
                    </span>
                    <span class="tip-text">审核通过后，开始前5分钟才会获得开门权限</span>
                </div>

                <button class="contact-btn" type="button" @click="contactManager">
                    联系项目管家
                </button>
            </div>

            <button class="primary-btn" type="button" @click="goMyBooking">
                查看我的预约
            </button>
            <button class="link-btn" type="button" @click="goHome">
                返回首页
            </button>
        </div>
    </div>
</template>

<script>
const WEEK_LABELS = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']

function pad(n) {
    return n < 10 ? `0${n}` : `${n}`
}

function formatKey(date) {
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

function parseDateKey(dateKey) {
    if (!dateKey) return null
    const parts = String(dateKey).split('-').map(Number)
    if (parts.length !== 3 || parts.some((n) => Number.isNaN(n))) return null
    return new Date(parts[0], parts[1] - 1, parts[2])
}

function buildDateLabel(dateKey) {
    const date = parseDateKey(dateKey)
    if (!date) return dateKey || ''

    const md = `${date.getMonth() + 1}/${pad(date.getDate())}`
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    const target = new Date(date)
    target.setHours(0, 0, 0, 0)
    const diffDays = Math.round((target - today) / 86400000)

    let dayText = WEEK_LABELS[date.getDay()]
    if (diffDays === 0) dayText = '今天'
    else if (diffDays === 1) dayText = '明天'
    else if (diffDays === 2) dayText = '后天'

    return `${md} · ${dayText}`
}

function splitTimeRange(timeRange) {
    const text = String(timeRange || '')
    const parts = text.split(/[—–-]/).map((s) => s.trim()).filter(Boolean)
    if (parts.length >= 2) {
        return { start: parts[0], end: parts[parts.length - 1] }
    }
    return { start: text || '--:--', end: '--:--' }
}

export default {
    name: 'submittedReviews',
    data() {
        return {
            roomName: '',
            location: '',
            dateKey: '',
            timeRange: '',
            adminPhone: '',
        }
    },
    computed: {
        dateLabel() {
            return buildDateLabel(this.dateKey)
        },
        startTime() {
            return splitTimeRange(this.timeRange).start
        },
        endTime() {
            return splitTimeRange(this.timeRange).end
        },
    },
    created() {
        this.initFromQuery()
    },
    methods: {
        initFromQuery() {
            const q = this.$route.query || {}
            this.roomName = q.name || ''
            this.location = q.location || ''
            this.dateKey = q.dateKey || formatKey(new Date())
            this.timeRange = q.timeRange || ''
            this.adminPhone = String(q.adminPhone || '').trim()
        },
        // 联系项目管家
        contactManager() {
            const phone = String(this.adminPhone || '').trim()
            if (!phone) {
                this.$toast && this.$toast('暂无项目管家联系电话')
                return
            }
            window.location.href = `tel:${phone}`
        },
        goMyBooking() {
            this.$router.replace('/myBooking')
        },
        goHome() {
            this.$router.replace('/home')
        },
    },
}
</script>

<style scoped>
.page {
    min-height: 100vh;
    background: linear-gradient(180deg, #e8f0fb 0%, #f3f6fb 38%, #f7f9fc 100%);
    box-sizing: border-box;
}

.content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1.2rem 0.4rem 0.8rem;
    box-sizing: border-box;
}

.success-icon {
    width: 1.12rem;
    height: 1.12rem;
}

.success-icon svg {
    width: 100%;
    height: 100%;
    display: block;
}

.success-sub {
    margin: 0.28rem 0 0;
    font-size: 0.26rem;
    color: #2f9b63;
    line-height: 1.4;
}

.success-title {
    margin: 0.12rem 0 0;
    font-size: 0.4rem;
    font-weight: 700;
    color: #1e3a5f;
    line-height: 1.35;
    text-align: center;
}

.booking-card {
    width: 100%;
    margin-top: 0.48rem;
    padding: 0.32rem 0.32rem 0.28rem;
    background: #ffffff;
    border-radius: 0.28rem;
    box-shadow: 0 0.1rem 0.32rem rgba(40, 90, 160, 0.08);
    box-sizing: border-box;
}

.card-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.date-text {
    font-size: 0.24rem;
    color: #8a9bb0;
}

.status-badge {
    padding: 0.04rem 0.14rem;
    border-radius: 0.2rem;
    background: #eaf2ff;
    color: #2b7de9;
    font-size: 0.2rem;
    line-height: 1.4;
}

.room-name {
    margin-top: 0.24rem;
    font-size: 0.34rem;
    font-weight: 700;
    color: #1e3a5f;
    line-height: 1.3;
}

.room-location {
    margin-top: 0.1rem;
    font-size: 0.22rem;
    color: #8a9bb0;
    line-height: 1.4;
}

.time-row {
    display: flex;
    align-items: center;
    margin-top: 0.32rem;
}

.time-val {
    flex-shrink: 0;
    font-size: 0.4rem;
    font-weight: 700;
    color: #1e3a5f;
    line-height: 1.2;
}

.time-line {
    flex: 1;
    height: 1px;
    margin: 0 0.24rem;
    background: linear-gradient(90deg, #d7e3f3 0%, #e8eef6 50%, #d7e3f3 100%);
}

.tip-box {
    display: flex;
    align-items: center;
    margin-top: 0.28rem;
    padding: 0.2rem 0.22rem;
    border-radius: 0.16rem;
    background: #f0f6ff;
    box-sizing: border-box;
}

.tip-icon {
    width: 0.32rem;
    height: 0.32rem;
    flex-shrink: 0;
    margin-right: 0.1rem;
}

.tip-icon svg {
    width: 100%;
    height: 100%;
    display: block;
}

.tip-text {
    font-size: 0.22rem;
    color: #6b86a8;
    line-height: 1.4;
}

.contact-btn {
    display: block;
    width: 100%;
    margin-top: 0.2rem;
    padding: 0.16rem 0 0.04rem;
    border: none;
    background: transparent;
    color: #2b7de9;
    font-size: 0.26rem;
    text-align: center;
    cursor: pointer;
}

.primary-btn {
    width: 100%;
    height: 0.96rem;
    margin-top: 0.4rem;
    border: none;
    border-radius: 0.48rem;
    background: #2b7de9;
    color: #ffffff;
    font-size: 0.32rem;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 0.1rem 0.24rem rgba(43, 125, 233, 0.28);
}

.primary-btn:active {
    opacity: 0.92;
}

.link-btn {
    margin-top: 0.28rem;
    padding: 0.12rem 0.24rem;
    border: none;
    background: transparent;
    color: #5a6f8a;
    font-size: 0.28rem;
    cursor: pointer;
}

.link-btn:active {
    opacity: 0.75;
}
</style>
